import { Modal, ModalHeader, ModalFooter, ModalBody, Button } from "reactstrap";
import { memo, useEffect, useState } from "react";

const ConfirmationModal = ({ showModal, onClose,onCancelHandle }) => {
  
    const [modal, setModal] = useState(false)

    useEffect(() => {
        setModal(showModal)
    }, [showModal])

    const toggleModal = () => {
        setModal(!modal)
        onCancelHandle()
    }

    const onConfirmClick = () => {
        setModal(!modal)
        onClose()
    }

    return (
        <>
            <Modal isOpen={modal} toggle={toggleModal} backdrop={"static"} fade={false}>
                <ModalHeader style={{ backgroundColor: 'lightblue' }}>
                    Confirm
                </ModalHeader>
                <ModalBody>
                <h5>Do you really want to close this window?</h5>
                    <h5>Please click cancel to save changes before close</h5>
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={toggleModal}>
                        Cancel
                    </Button> {' '}
                    <Button color="danger" onClick={onConfirmClick}>
                        Close
                    </Button>
                </ModalFooter>
            </Modal>

        </>
    )
}

export default memo(ConfirmationModal)
